import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triangle\"><defs><style></style></defs><path d=\"M535.467 812.8L985.6 249.6c14.933-19.2 2.133-49.067-23.467-49.067H61.867c-25.6 0-38.4 29.867-23.467 49.067l450.133 563.2c12.8 14.933 34.134 14.933 46.934 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol